(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-electric-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.hcErReady === 'true') return;
      root.dataset.hcErReady = 'true';
      const panels = Array.from(root.querySelectorAll('[data-hc-er-panel]'));
      const button = root.querySelector('[data-hc-er-flash]');

      const activatePanel = (selectedPanel) => {
        panels.forEach((panel) => {
          const isActive = panel === selectedPanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      panels.forEach((panel) => {
        panel.addEventListener('click', () => activatePanel(panel));
      });

      if (!button) return;
      let timer;
      button.addEventListener('click', () => {
        root.classList.remove('is-flashing');
        window.requestAnimationFrame(() => {
          root.classList.add('is-flashing');
          root.classList.toggle('is-charged');
          window.clearTimeout(timer);
          timer = window.setTimeout(() => root.classList.remove('is-flashing'), 650);
        });
      });
    };

    document.querySelectorAll('[data-hc-er-hero]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-hc-er-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-electric-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.hcErReady === 'true') return;
      root.dataset.hcErReady = 'true';
      root.querySelectorAll('[data-hc-er-story-flash]').forEach((button) => {
        button.addEventListener('click', () => root.classList.toggle('is-charged'));
      });
    };

    document.querySelectorAll('[data-hc-er-story]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-hc-er-story]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-electric-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hc-proof]').forEach((proof) => {
    const tabs = Array.from(proof.querySelectorAll('[data-hc-proof-tab]'));
    const panels = Array.from(proof.querySelectorAll('[data-hc-proof-panel]'));

    const selectTab = (nextTab) => {
      const nextName = nextTab.dataset.hcProofTab;

      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.hcProofPanel !== nextName;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const step = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(index + step + tabs.length) % tabs.length];
        selectTab(nextTab);
        nextTab.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
